import React from 'react';

const ExperienceHero = ({ experienceKey = '', image, title, subtitle, style = {} }) => {
  const heroClassName = ['hero', 'experience-hero', experienceKey ? `experience-hero--${experienceKey}` : '']
    .filter(Boolean)
    .join(' ');
  const titleClassName = [
    'title',
    'dark',
    'experience-hero-title',
    experienceKey ? `experience-hero-title--${experienceKey}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <section
        className={heroClassName}
        style={style}
      >
        {image && (
          <img
            className="experience-hero__image"
            src={image}
            alt=""
          />
        )}
      </section>
      <section className={titleClassName}>
        <div className="inner experience-hero-title__inner">
          <h1 className="experience-hero-title__heading">
            {title}
            {subtitle && <p className="hero-subtitle experience-hero-title__subtitle">{subtitle}</p>}
          </h1>
          <span className="icon-arrow-down experience-hero-title__arrow"></span>
        </div>
      </section>
    </>
  );
};

export default ExperienceHero;
